import { EXPRESS_API } from 'configs/api/expressApi';
import {
  IQuickVideoCategoryOption,
  IQuickVideoPartOption,
  IQuickVideoPartPositionOption,
} from './types';
import { useQuery } from 'react-query';
import { quickVideoKeys } from './quickVideoKeys';
import { useToastError } from 'lib/hooks';

interface IQuickVideoConfigurationResponse {
  parts: IQuickVideoPartOption[];
  positions: IQuickVideoPartPositionOption[];
  categories: IQuickVideoCategoryOption[];
}

const getConfiguration = async () => {
  return (await EXPRESS_API.get(`/quick-videos/configuration`))
    .data as IQuickVideoConfigurationResponse;
};

export const useGetConfiguration = () => {
  const { showError } = useToastError();
  return useQuery(quickVideoKeys.configuration(), getConfiguration, {
    onError: err => {
      showError(err);
    },
  });
};
